import { get } from 'services/request.service';
import { getEnv } from 'services/apiEnv.service';
import { SOPDocument } from './sap-odata.types';

const BASE_URL = `${getEnv('IT_BASE_URL')}/sap-odata`;

export const getSOPDocumentList = async (): Promise<SOPDocument[]> => {
  return (await get({ url: `${BASE_URL}/sop-documents` })).data;
};
